import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useDarkMode } from '../context/DarkModeContext';
import theme from '../theme';

const BLOG_RE = /^\/blog(\/|$)/;

/**
 * ContextApplier — pure side-effect component.
 * Watches route + dark mode and applies CSS custom properties + data-context
 * attribute so index.css rules can target blog vs app contexts.
 * Must be rendered inside both <BrowserRouter> and <DarkModeProvider>.
 */
export default function ContextApplier() {
  const { dark }     = useDarkMode();
  const { pathname } = useLocation();
  const isBlog       = BLOG_RE.test(pathname);

  useEffect(() => {
    theme.applyTheme(dark, isBlog);

    const main = document.querySelector('main');
    if (main) {
      if (isBlog) {
        main.setAttribute('data-context', 'blog');
      } else {
        main.removeAttribute('data-context');
      }
    }
  }, [dark, isBlog]);

  return null;
}
